var DistanceUnit;
(function(DistanceUnit) {
    DistanceUnit["km"] = "km";
    DistanceUnit["meter"] = "meter";
    DistanceUnit["mile"] = "mile";
})(DistanceUnit || (DistanceUnit = {}));

export { DistanceUnit };
//# sourceMappingURL=utils.js.map
